import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { cn } from "../../../../utils/utils";

/**
 * Card used inside the Report Library grid on the hub.
 * Props:
 *   item: { id, to, label, description, icon, status, iconTone }
 *   hint: optional React node rendered above the CTA (e.g. "7 giai đoạn")
 */
const ReportCard = ({ item, hint }) => {
  const Icon = item.icon;
  const isSoon = item.status === "soon";
  const Wrapper = isSoon ? "div" : Link;
  const wrapperProps = isSoon
    ? { "aria-disabled": true }
    : { to: item.to };

  return (
    <Wrapper
      {...wrapperProps}
      className={cn(
        "group relative flex flex-col rounded-xl border border-gray-200 bg-white p-4 transition-all",
        isSoon
          ? "opacity-70 cursor-not-allowed"
          : "hover:border-blue-300 hover:shadow-md hover:-translate-y-0.5",
      )}
    >
      <div className="flex items-start justify-between gap-2">
        <div
          className={cn(
            "w-10 h-10 rounded-lg flex items-center justify-center",
            item.iconTone || "bg-blue-50 text-blue-600",
          )}
        >
          {Icon && <Icon size={20} />}
        </div>
        {isSoon && (
          <span className="inline-flex items-center gap-1 text-[10px] font-medium bg-gray-100 text-gray-500 px-1.5 py-0.5 rounded-full">
            <Sparkles size={10} />
            Sắp ra mắt
          </span>
        )}
      </div>

      <div className="mt-3 flex-1">
        <div className="text-sm font-semibold text-gray-900">{item.label}</div>
        <p className="text-xs text-gray-500 mt-1 line-clamp-2 leading-relaxed">
          {item.description}
        </p>
      </div>

      <div className="mt-3 pt-3 border-t border-gray-100 flex items-center justify-between">
        <div className="text-xs text-gray-500 min-h-[16px]">{hint || "\u00A0"}</div>
        {!isSoon && (
          <span className="inline-flex items-center gap-1 text-xs font-medium text-blue-600 group-hover:underline">
            Xem
            <ArrowRight
              size={12}
              className="transition-transform group-hover:translate-x-0.5"
            />
          </span>
        )}
      </div>
    </Wrapper>
  );
};

export default ReportCard;
